<template>
  <v-card>
      <v-card-title>
        <div>
          <div class="headline">Product ISO Country</div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.ctyDesc }}</td>
          <td class="text-xs-left">{{ props.item.travelAreaBySingleTripAreaDesc }}</td>
          <td class="text-xs-left">{{ props.item.travelAreaByMultiTripAreaDesc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" remove review @review="doReview" @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click.native="doNew()">New ISO Country<v-icon>mdi-plus</v-icon></v-btn>
      <v-dialog v-model="ISOCountryDialog" max-width="600px" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Permit ISO Country for Product</span>
          </v-card-title>
          <v-card-text>
            <message :messages="messages"></message>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 class="ma-2" v-if="!newISOCountry">
                  <v-subheader class="queryLabel">{{labels.ctyQuery}}</v-subheader>
                  <div class="title">{{labels.ctyDesc}}</div>
                </v-flex>
                <v-flex xs12 v-else>
                  <v-autocomplete :label="labels.cty" v-model="isoCountryForm.cty" :items="isoCountryList" item-text="label" item-value="value" :error-messages="errors.first('product') ? errors.first('product') : errors.collect('cty')" data-vv-name="cty" :data-vv-as="labels.cty" v-validate="'required'" :loading="isoCountryLoading"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete :label="labels.travelAreaBySingleTripArea" v-model="isoCountryForm.travelAreaBySingleTripArea" :items="travelAreaList" item-text="label" item-value="value" :error-messages="errors.collect('travelAreaBySingleTripArea')" data-vv-name="travelAreaBySingleTripArea" :data-vv-as="labels.travelAreaBySingleTripArea" :loading="travelAreaLoading"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete :label="labels.travelAreaByMultiTripArea" v-model="isoCountryForm.travelAreaByMultiTripArea" :items="travelAreaList" item-text="label" item-value="value" :error-messages="errors.collect('travelAreaByMultiTripArea')" data-vv-name="travelAreaByMultiTripArea" :data-vv-as="labels.travelAreaByMultiTripArea" :loading="travelAreaLoading"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
            <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Permitted ISO Country?
        <div class="title">{{deleteProductISOCountry}}</div>
      </confirm>
    </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import FieldMixin from '@/mixins/field'
export default {
  data() {
    return {
      headers: [
        { text: 'Country', value: 'ctyDesc' },
        { text: 'Single Trip Area', value: 'travelAreaBySingleTripAreaDesc' },
        { text: 'Multi Trip Area', value: 'travelAreaByMultiTripAreaDesc' },
        TableConst.tableActionHeader
      ],
      pagination: {
        sortBy: 'effDate'
      },
      labels: {
        ctyQuery: 'Country',
        cty: 'Country*',
        ctyDesc: null,
        travelAreaBySingleTripArea: 'Single Trip',
        travelAreaByMultiTripArea: 'Mutli Trip'
      },
      isoCountryForm: {
        product: null,
        cty: null,
        travelAreaBySingleTripArea: null,
        travelAreaByMultiTripArea: null
      },
      isoCountryList: [],
      travelAreaList: [],
      isoCountryLoading: false,
      travelAreaLoading: false,
      loading: false,
      deleteProductISOCountry: '',
      promptRemove: false,
      newISOCountry: false,
      ISOCountryDialog: false
    }
  },
  computed: {
    productMenu() {
      return this.$store.state.productManagement.product.menu
    }
  },
  methods: {
    async doInit() {
      await this.$store.dispatch('productMenuInit', this.product)
      this.isoCountryForm.product = this.product
      await this.fetchData(this.product)
      await this.getCountryList()
      await this.getTravelAreaList()
    },
    async fetchData(xproduct) {
      this.loading = true
      const apiURI = this.productMenu.isoCountryProducts
      if (apiURI) {
        try {
          const expand = {
            product: xproduct
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((isoCountryProduct) => {
              const convertList = {
                product: isoCountryProduct.product,
                cty: isoCountryProduct.cty,
                ctyDesc: isoCountryProduct.ctyDesc,
                travelAreaBySingleTripArea: isoCountryProduct.travelAreaBySingleTripArea,
                travelAreaBySingleTripAreaDesc: isoCountryProduct.travelAreaBySingleTripArea + ' - ' + isoCountryProduct.travelAreaBySingleTripAreaDesc,
                travelAreaByMultiTripArea: isoCountryProduct.travelAreaByMultiTripArea,
                travelAreaByMultiTripAreaDesc: isoCountryProduct.travelAreaByMultiTripArea + ' - ' + isoCountryProduct.travelAreaByMultiTripAreaDesc
              }
              this.items.push(convertList)
            })
            this.loading = false
          } else {
            this.items = []
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
            this.loading = false
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Product ISO Country')
        this.loading = false
      }
    },
    async doReview(item) {
      this.newISOCountry = false
      const apiURI = this.productMenu.isoCountryProduct
      if (apiURI) {
        try {
          const expand = {
            appID: this.appID,
            product: item.item.product,
            ISOCountry: item.item.cty
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.isoCountryForm.product = data.productISOCountry.product
            this.isoCountryForm.cty = data.productISOCountry.cty
            this.labels.ctyDesc = data.productISOCountry.ctyDesc
            this.isoCountryForm.travelAreaBySingleTripArea = data.productISOCountry.travelAreaBySingleTripArea
            this.isoCountryForm.travelAreaByMultiTripArea = data.productISOCountry.travelAreaByMultiTripArea
            this.ISOCountryDialog = true
          } else {
            this.$snotify.error('Invalid Data - Product Discount / Loading Review')
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Product Discount / Loading Review')
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newISOCountry) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.productMenu.isoCountryProductUpdate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.isoCountryForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            await this.fetchData(this.isoCountryForm.product)
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Product Discount / Loading Update')
      }
    },
    async doCreate() {
      const apiURI = this.productMenu.isoCountryProductCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.isoCountryForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            await this.fetchData(this.isoCountryForm.product)
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Product Discount / Loading Create')
      }
    },
    doClose() {
      this.resetMessages()
      this.newISOCountry = false
      this.isoCountryForm.cty = undefined
      this.isoCountryForm.travelAreaBySingleTripArea = undefined
      this.isoCountryForm.travelAreaByMultiTripArea = undefined
      this.ISOCountryDialog = false
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProductISOCountry = data
        this.deleteProductISOCountry = data.ISOCountryDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.productManagement.product.menu.isoCountryProductDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          cty: this.selectedProductISOCountry.cty,
          product: this.product,
          travelAreaBySingleTripArea: this.selectedProductISOCountry.travelAreaBySingleTripArea,
          travelAreaByMultiTripArea: this.selectedProductISOCountry.travelAreaByMultiTripArea
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.doInit()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Product Discount Loading')
      }
    },
    async doNew() {
      this.resetMessages()
      this.isoCountryForm.cty = undefined
      this.isoCountryForm.travelAreaBySingleTripArea = undefined
      this.isoCountryForm.travelAreaByMultiTripArea = undefined
      this.newISOCountry = true
      this.ISOCountryDialog = true
      await this.getCountryList()
      await this.getTravelAreaList()
    },
    async getCountryList() {
      const apiURI = this.productMenu.isoCountryList
      if (apiURI) {
        try {
          this.isoCountryLoading = true
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.isoCountryList = data
          }
          this.isoCountryLoading = false
        } catch (err) {
          throw err
        }
      } else {
        this.errorMessage('Invalid API URL - Product ISO Country List')
      }
    },
    async getTravelAreaList() {
      const apiURI = this.productMenu.travelAreaList
      if (apiURI) {
        try {
          this.travelAreaLoading = true
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.travelAreaList = data
          }
          this.travelAreaLoading = false
        } catch (err) {
          throw err
        }
      } else {
        this.errorMessage('Invalid API URL - Product Travel Area List')
      }
    }
  },
  created() {
    if (this.product === 'new') {
      this.newProduct = true
    } else {
      Promise.all([this.doInit()])
    }
  },
  props: {
    product: {
      type: String,
      default: ''
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
